import Loader from './loader';
import styles from './fullPageLoader.module.scss';

const FullPageLoader = () => {
    return (
        <div
            className={styles['loader-wrapper']}
            style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/login.svg))` }}
        >
            <Loader className={styles.loader} showBackground />
        </div>
    );
};

export default FullPageLoader;
